"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MATCH_AUTH0_CALLBACK_HASH = void 0;
// regex to match Auth0callback URL hash parameters
var MATCH_AUTH0_CALLBACK_HASH = /access_token|id_token|error/; // function to tell us if we're at a callback URL page

exports.MATCH_AUTH0_CALLBACK_HASH = MATCH_AUTH0_CALLBACK_HASH;
var isAuth0CallbackUrl = function isAuth0CallbackUrl() {
  return MATCH_AUTH0_CALLBACK_HASH.test(window.location.hash);
};
var _default = isAuth0CallbackUrl;
exports.default = _default;